export const NumberOfRooms =  (val: number) =>{
    if (val % 1 === 0) {
       return val.toFixed(0);
    } else {
       return val.toFixed(1);
    }
 }
